import { ChangeDetectionStrategy, Component } from '@angular/core';


@Component({
    selector: 'app-legal',
    templateUrl: './legal.component.html',
    styleUrls: ['./legal.component.css'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LegalComponent {

}

